module.exports = __webpack_public_path__ + "img/cooperate_yx_02@2x.b043bb45.png";